<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputWhat" placeholder="请输入姓名或手机号" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" icon="el-icon-search" @click="find">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" ref="table" border v-loading="listloading" style="width: 99.9%" :max-height="maxHeight" @filter-change="Filterfind">
		    <el-table-column label="姓名" prop="name"></el-table-column>
		    <el-table-column label="手机" prop="phone"></el-table-column>
		    <el-table-column label="常住地">
		    	<template slot-scope="scope">
					<span>{{scope.row.province}} {{scope.row.city}}</span>
				</template>
		    </el-table-column>
		    <el-table-column label="类别" prop="type" column-key="type" :filters="typefilt">
		    	<template slot-scope="scope">
					<span v-if="scope.row.type == 1">个人用户</span>
					<span v-if="scope.row.type == 2">商业合作</span>
					<span v-if="scope.row.type == 3">政府关系</span>
				</template>
		    </el-table-column>
			<!--<el-table-column fixed="right" label="时间" prop="time" width="180" :formatter="dateFormat"></el-table-column>-->
  		</el-table>
  		
  		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="prev, pager, next,jumper" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</div>
</template>

<script>
	import {GetActiveUserlist} from '../api/api';
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:600,
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				List:[],
				Findform:"",
				inputWhat:"",
				typeChoose:[],
				typefilt:[{text:'个人用户',value:'1'},{text:'商业合作',value:'2'},{text:'政府关系',value:'3'}],
				lastData:[]
			}
		},
		methods:{
			handleCurrentChange(val){
				this.Curpage = val
				this.find()
			},
			Refresh(){
//				console.log(this)
				this.inputWhat = ""
				this.$refs.table.clearFilter()
				this.typeChoose = []
				this.GetList(GetActiveUserlist,{page:this.Curpage,token:this.token,sort:'-id'})
			},
			Filterfind(filters){
				var that =  this
				that.typeChoose = filters.type
				that.find()
			},
			find(){
				var that =  this
				if(that.inputWhat){
					var flag = that.isNumber(that.inputWhat)
					if(flag){
						if(that.typeChoose.length > 0){
							that.lastData = [{AND:{"phone":"~" + that.inputWhat,"type":that.typeChoose}}]
						}else{
							that.lastData = [{AND:{"phone":"~" + that.inputWhat}}]
						}
					}else{
						if(that.typeChoose.length > 0){
							that.lastData = [{AND:{"name":"~" + that.inputWhat,"type":that.typeChoose}}]
						}else{
							that.lastData = [{AND:{"name":"~" + that.inputWhat}}]
						}
					}
//					console.log(that.lastData)
					that.lastData2 = JSON.stringify(that.lastData)
					this.GetList(GetActiveUserlist,{page:this.Curpage,token:this.token,sort:'-id',q:that.lastData2})
				}else if(!that.inputWhat && that.typeChoose.length > 0){
					that.lastData = [{AND:{"type":that.typeChoose}}]
					that.lastData2 = JSON.stringify(that.lastData)
//					console.log(that.lastData)
					this.GetList(GetActiveUserlist,{page:this.Curpage,token:this.token,sort:'-id',q:that.lastData2})
				}else{
					this.GetList(GetActiveUserlist,{page:this.Curpage,token:this.token,sort:'-id'})
				}
				
			},
			isNumber(val) {
			    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
			    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
			    if(regPos.test(val) || regNeg.test(val)) {
			        return true;
			    } else {
			        return false;
			    }
			}
			
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList(GetActiveUserlist,{page:this.Curpage,token:this.token,sort:'-id'})
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ActiveUser.vue?04940289